export default "__VITE_ASSET__DxYCL3Ky__"